// Legacy threshold from apps/legacy/src/components/assesment/utils/question/video.jsx:54.
// downlink is in Mbps; multiplying by 1000 produces kbps. The check is strict-less-than 400.
// navigator.connection is unavailable on Safari and Firefox — returns false there (no advisory).
export function isLowBandwidth() {
  const c = typeof navigator !== 'undefined' ? navigator.connection : null;
  if (!c || typeof c.downlink !== 'number') return false;
  return c.downlink * 1000 < 400;
}
